import React, { useMemo } from 'react';
import { KeyMetricData } from 'src/types';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
import { useMergeBenchmarkTimeseries } from 'src/hooks/useMergeBenchmarkTimeseries';
import { calculateTrendFromTimeSeries } from 'src/utils/calculateTrendFromTimeSeries';
import { useDADataContext } from '../../../contexts/DADataContext';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { CircleDollarSign } from 'lucide-react';

export const Spend: React.FC = () => {
  const { investments, benchmarkInvestments } = useDADataContext();
  const { getMergedTimeSeries } = useMergeBenchmarkTimeseries();

  const keyMetricData: KeyMetricData = useMemo(() => {
    let sum = 0;
    investments.daily.forEach((x) => {
      sum += x.totalInvestment;
    });

    const data = getMergedTimeSeries(
      investments.daily,
      benchmarkInvestments.daily,
      (v) => ({ value: v.totalInvestment }),
      (v) => ({ benchmark: v.totalInvestment }),
      false,
      'day',
    );

    return {
      name: 'Spend',
      data,
      isEuro: true,
      summaryValue: sum,
      isError: investments.isError,
      isLoading: investments.isLoading,
    };
  }, [investments, getMergedTimeSeries, benchmarkInvestments]);

  const { trend, trendValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricCard
      title="Spend"
      trend={trend}
      trendValue={trendValue}
      value={keyMetricData.summaryValue}
      isLoading={keyMetricData.isLoading}
      isError={keyMetricData.isError}
      icon={<ChakraIcon as={CircleDollarSign} boxSize={5} color="gray.500" />}
    />
  );
};
